// src/belediye/components/BelediyeLogoutButton.js


import React from "react";
import { ArrowRightOnRectangleIcon } from "@heroicons/react/24/outline";
import "./BelediyeLogoutButton.css";


import belediyeApi, { withoutGlobalLoader } from "../services/belediyeApi";

// ─────────────────────────────────────────────────────────────────────────────
// localStorage anahtarları
// ─────────────────────────────────────────────────────────────────────────────
const LS = {
  accessToken: "accessToken",
  refreshToken: "refreshToken",
  user: "user",
  activeUnitId: "activeUnitId",
  activeUnitSlug: "activeUnitSlug",
  activeEffectiveRole: "activeEffectiveRole",
  legacyToken: "token",
};

const clearLocalStorage = () => {
  try {
    Object.values(LS).forEach((k) => localStorage.removeItem(k));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn("[logout] localStorage temizleme hatasi:", err);
  }
};

// JSON.stringify ile yazılmış olabilir, raw string olabilir
const readToken = (key) => {
  try {
    const v = localStorage.getItem(key);
    if (!v) return null;
    try {
      const parsed = JSON.parse(v);
      if (typeof parsed === "string") return parsed;
    } catch {
      // raw string
    }
    return v;
  } catch {
    return null;
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// notifyBackendLogout — belediyeApi (axios) kullanarak istek
// ─────────────────────────────────────────────────────────────────────────────
const notifyBackendLogout = async () => {
  console.log("[logout] === Backend bilgilendirme baslatiliyor ===");

  const accessToken = readToken(LS.accessToken) || readToken(LS.legacyToken);
  const refreshToken = readToken(LS.refreshToken);

  console.log("[logout] accessToken var mi?:", Boolean(accessToken));
  console.log("[logout] refreshToken var mi?:", Boolean(refreshToken));

  if (!accessToken) {
    console.warn("[logout] accessToken yok, backend'e haber verilmiyor");
    return { ok: false, reason: "no_token" };
  }

  // Body — refresh token varsa gönder (blacklist için)
  const payload = refreshToken ? { refresh: refreshToken } : {};

  try {
    const response = await belediyeApi.post(
      "/logout/",   // baseURL: ".../api"  →  ".../api/logout/"
      payload,
      withoutGlobalLoader({
        timeout: 5000,
        // Bu istekte 401 retry mantığı çalışmasın, doğrudan başarısız olsun
        // (response interceptor zaten 401'de refresh dener; logout sırasında
        //  bu gereksiz, ama mevcut interceptor mantığı zarar vermez)
      })
    );

    console.log("[logout] HTTP status:", response.status);
    console.log("[logout] Response data:", response.data);
    console.log("[logout] Backend basariyla bilgilendirildi");

    return { ok: true, status: response.status, data: response.data };
  } catch (err) {
    const status = err?.response?.status;
    const data = err?.response?.data;
    console.error(
      "[logout] Backend istegi BASARISIZ. status=%s data=%o err=%s",
      status, data, err?.message || err
    );
    return { ok: false, status, data, error: String(err?.message || err) };
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// performLogout — Programmatik çıkış (named export)
// ─────────────────────────────────────────────────────────────────────────────
//
// Akış:
//   1. Backend'e POST /api/logout/  (axios üzerinden)
//   2. localStorage tamamen temizle
//   3. /giris sayfasına full reload ile yönlendir
//
// Hata olursa adım 1 başarısız olsa bile 2 ve 3 yine çalışır.
// ─────────────────────────────────────────────────────────────────────────────
export const performLogout = async () => {
  console.log("[logout] === performLogout baslatildi ===");

  let result = { ok: false };
  try {
    result = await notifyBackendLogout();
  } catch (err) {
    console.error("[logout] performLogout backend asamasinda exception:", err);
  }
  console.log("[logout] Backend sonucu:", result);

  console.log("[logout] localStorage temizleniyor");
  clearLocalStorage();

  console.log("[logout] /giris'e yonlendiriliyor");
  try {
    window.location.href = "/giris";
  } catch {
    // test ortami
  }
};

// ─────────────────────────────────────────────────────────────────────────────
// UI Bileşeni
// ─────────────────────────────────────────────────────────────────────────────
const BelediyeLogoutButton = ({ onLogout }) => {
  const handleClick = async () => {
    if (typeof onLogout === "function") {
      try {
        await onLogout();
        return;
      } catch (err) {
        console.warn("[logout] custom onLogout hata, default'a doneriz:", err);
      }
    }
    await performLogout();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="logout-btn"
      aria-label="Çıkış Yap"
    >
      <ArrowRightOnRectangleIcon className="logout-btn-icon" />
      <span className="logout-btn-text">Çıkış</span>
    </button>
  );
};

export default BelediyeLogoutButton;